import React from "react";
import fieldPropTypes from "./field-prop-types";
import parseValue from "../utils/parse-value";

const WebImage = ({
  field,
  components: { WebImage: WebImageView, Loader },
  appData
}) => {
  const imageProps = appData.properLink
    ? { url: field.url || field.image, properLink: appData.properLink }
    : { url: field.url, image: field.image };

  // TODO: Create modernizedWebImage field or extand this one
  const {
    params = " ",
    url,
    text = "{0,0}", // this is how I get value key, check web_image_field.rb in mobile_api
    placeholder = " ",
    padding = "{0,0,0,0}",
    image = ""
  } = field;
  const isCircle = params.includes("TDFieldOptionCircleShape");
  const isFullWidth = params.includes("TDFieldOptionEdgeToEdge");
  const [width, height] = parseValue(text);
  const [marginTop, marginLeft, marginBottom, marginRight] =
    parseValue(padding);
  const style = {
    width: isFullWidth ? "100%" : width,
    height: isFullWidth ? "auto" : isCircle ? width : height,
    marginBottom,
    marginLeft,
    marginTop,
    marginRight,
    alignContent: "center",
    borderRadius: isCircle && !isFullWidth ? width : 0
  };
  const modernizedWebImage = isCircle || isFullWidth;

  return modernizedWebImage ? (
    <img src={url || image} alt={placeholder} style={style} />
  ) : (
    <WebImageView
      {...imageProps}
      size={field.size}
      align={field.align}
      components={{ Loader }}
      params={field.params}
      title={field.title}
      layout={field.layout}
    />
  );
};

WebImage.propTypes = fieldPropTypes;

export default WebImage;
